import React, { Fragment } from 'react'
import {
    List, Datagrid, Filter, ShowButton, UrlField,Button, TextInput, TextField, EditButton, BulkDeleteButton, FunctionField, DeleteButton, useRecordContext, Link
} from 'react-admin'
import { InfluencerStatusSelectInput } from '../../UI/Input/SelectInput'
import DownloadIcon from '@material-ui/icons/GetApp';
import useCheckPermissions from '../AdminPermissions/useCheckPermissions'

const ListFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="q" alwaysOn />
    </Filter>
)
const ListActionButtons = ({ ...props }) => {
    return (<>
        <BulkDeleteButton {...props} undoable={false}
            confirmTitle="Delete File Record"
            confirmContent={"Are you sure you want to delete this record?"} />
    </>)
}
const ProfileidFiled = (props)=>{
    const record = useRecordContext();  
    return (
    <TextField {...props} component={Link} to={`/user?filter={"q":"${record.profile_id}"}`} onClick={(event)=>event.stopPropagation()} />
  )}


const ContentReviewList = ({ ...props }) => {

    return (
        <List {...props} title="Influencer" bulkActionButtons={<ListActionButtons />} filters={<ListFilter />} sort={{ field: 'title', order: 'ASC' }}>

            <Datagrid >
                
                <ProfileidFiled source="profile_id" label="Profile Id" />  
                <TextField source='name' label="name" />
              
                <TextField source="rating" label="Rating" />
                 <TextField source="task_amount" label="Task Amount" />
                <TextField source="contentreviewerquestionone" label="Content Review Question One" />
                 <TextField source="contentreviewerquestiontwo" label="Content Review Question Two" />
                  <TextField source="contentreviewerquestionthree" label="Content Review Question Three" />

                   <TextField source="contentreviewerquestioninputone" label="Content Review Question Input One" />
                    <TextField source="contentreviewerquestioninputtwo" label="Content Review Question Input Two" />
                    <TextField source="contentreviewerquestioninputthree" label="Content Review Question Input Three" />
              
                <TextField source='created_at' label="Created At" />
             

            </Datagrid>

        </List>
    )
}


export default ContentReviewList